import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
    AppBar,
    Box,
    Toolbar,
    Typography,
    Container,
    IconButton,
    Menu,
    MenuItem,
    Button
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Footer from '../../Components/Footer';

const AdminLayout = () => {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate();

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => setAnchorElNav(null);

    const pages = [
        { id: 1, name: 'Home', route: '/admin' },
        { id: 2, name: 'Users', route: '/admin/users' },
        { id: 3, name: 'Settings', route: '/admin/settings' },
        { id: 4, name: 'Messages', route: '/admin/messages' },
    ];

    const handleClick = (route: string) => {
        navigate(route);
        handleCloseNavMenu();
    };

    const handleLogout = () => {
        navigate('/login');
    };

    return (
        <Box>
            <AppBar position="static" color="primary">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {/* Admin title */}
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ flexGrow: 1, fontWeight: 600 }}
                        >
                            Admin Dashboard
                        </Typography>

                        {/* Desktop menu */}
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
                            {pages.map((page) => (
                                <Button
                                    key={page.id}
                                    color="inherit"
                                    onClick={() => handleClick(page.route)}
                                >
                                    {page.name}
                                </Button>
                            ))}
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleLogout}
                            >
                                Logout
                            </Button>
                        </Box>

                        {/* Mobile menu icon */}
                        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                color='inherit'
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page.id} onClick={() => handleClick(page.route)}>
                                        {page.name}
                                    </MenuItem>
                                ))}
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>

            {/* Content */}
            <Container maxWidth="lg" sx={{ mt: 6 }}>
                <Outlet />
            </Container>

            {/* Footer */}
            <Footer />
        </Box>
    );
};

export default AdminLayout;